export const SET_TESTIMONIALS = 'SET_TESTIMONIALS'
export const SET_TESTIMONIAL = 'SET_TESTIMONIAL'
